<div class="space-y-4">
  <div class="overflow-hidden rounded-lg border border-base-content/20">
    <div class="border-b border-base-300/40 bg-base-300/10 px-4 py-3">
      <div class="text-lg font-semibold">{{ tenant.company }}</div>
      <div class="font-mono text-sm text-base-content/70">
        Account # {{ tenant.account_number }}
      </div>
    </div>

    <div
      class="grid grid-cols-1 gap-x-6 gap-y-6 px-4 py-4 sm:grid-cols-2 lg:grid-cols-3"
    >
      <div class="min-w-0 sm:col-span-2 lg:col-span-3">
        <div [class]="fieldLabelClass">Address</div>
        <div class="break-words text-base">
          <p>{{ tenant.address }}</p>
          <p>{{ tenant.city }}, {{ tenant.st }} {{ tenant.zip }}</p>
        </div>
      </div>

      <div class="min-w-0 sm:col-span-2 lg:col-span-3">
        <div [class]="fieldLabelClass">Billing address</div>
        <div class="break-words text-base">
          @if (tenant.billing_address) {
            @if (tenant.billing_address !== tenant.address) {
              <p>{{ tenant.billing_address }}</p>
              <p>
                {{ tenant.billing_city }}, {{ tenant.billing_st }}
                {{ tenant.billing_zip }}
              </p>
            } @else {
              <p class="text-base-content/70">Same as shipping</p>
            }
          } @else {
            <p class="text-base-content/70">N/A</p>
          }
        </div>
      </div>

      <div class="min-w-0">
        <div [class]="fieldLabelClass">Emails</div>
        <div class="break-words text-base">
          @for (email of tenant.emails; track email) {
            <p class="break-all">{{ email }}</p>
          } @empty {
            <p class="text-base-content/70">No emails</p>
          }
        </div>
      </div>

      <div class="min-w-0">
        <div [class]="fieldLabelClass">Billing emails</div>
        <div class="break-words text-base">
          @for (email of tenant.billing_emails; track email) {
            <p class="break-all">{{ email }}</p>
          } @empty {
            <p class="text-base-content/70">No billing emails</p>
          }
        </div>
      </div>

      <div class="min-w-0">
        <div [class]="fieldLabelClass">Phone</div>
        <div class="break-words text-base">
          @if (tenant.phone1) {
            <p>{{ tenant.phone1 }}</p>
          }
          @if (tenant.phone2) {
            <p>{{ tenant.phone2 }}</p>
          }
          @if (!tenant.phone1 && !tenant.phone2) {
            <p class="text-base-content/70">No phone numbers</p>
          }
        </div>
      </div>

      <div class="min-w-0">
        <div [class]="fieldLabelClass">QBO / Avatax</div>
        <div class="break-words text-base">
          @if (tenant.avatax_customer_code) {
            <a
              class="link font-medium"
              [href]="getQuickbooksCustomerLink(tenant.avatax_customer_code)"
              target="_blank"
              rel="noopener noreferrer"
              >{{ tenant.avatax_customer_code }}</a
            >
          } @else {
            <p class="text-base-content/70">N/A</p>
          }
        </div>
      </div>

      <div class="min-w-0">
        <div [class]="fieldLabelClass">Franchise</div>
        <div class="break-words text-base">
          @if (franchise) {
            <a
              class="link font-medium"
              [routerLink]="'/admin/franchise/' + franchise.id"
              >{{ franchise.name }}</a
            >
          } @else {
            <p class="text-base-content/70">N/A</p>
          }
        </div>
      </div>

      <div class="min-w-0">
        <div [class]="fieldLabelClass">Ignore API invoices</div>
        <div class="break-words text-base">
          {{ tenant.ignore_api_invoices ? 'Yes' : 'No' }}
        </div>
      </div>

      <div class="col-span-2 min-w-0">
        <div [class]="fieldLabelClass">
          PAF UUID
          @if (pafUUID) {
            <app-file-copy-icon
              (click)="copyPafUuid($event)"
              class="mb-[-4px] ml-2 inline-block h-4 w-4 cursor-pointer"
              title="Copy PAF UUID"
            />
          }
        </div>
        @if (loadingRegistrationDb) {
          <div class="skeleton h-4 w-full"></div>
        } @else if (pafUUID) {
          <div class="break-keep text-base">
            {{ pafUUID }}
          </div>
        } @else {
          <div class="text-base-content/70">N/A</div>
        }
      </div>

      <div class="min-w-0">
        <div [class]="fieldLabelClass">Created</div>
        <div class="break-words text-base">
          {{ tenant.created_at | date: 'MM/dd/yyyy, hh:mmaa' }}
        </div>
      </div>

      <div class="min-w-0 sm:col-span-2 lg:col-span-3">
        <div [class]="fieldLabelClass">Notes</div>
        <textarea
          class="textarea textarea-bordered w-full max-w-xl text-sm"
          rows="4"
          readonly
          >{{ tenant.notes }}</textarea
        >
      </div>
    </div>

    <div class="border-t border-base-300/40 bg-base-300/10 px-4 py-3">
      <button class="btn btn-outline btn-sm" [routerLink]="'./edit'">
        Edit Tenant
      </button>
    </div>
  </div>

  @if (!tenantAddressValid(tenant)) {
    <div class="alert alert-warning text-sm">
      <span>
        This tenant's address is not valid. We're unable to create invoices for
        this tenant until it is updated. The address is required for tax
        calculations.
      </span>
    </div>
  }
  @if (!tenant.avatax_customer_code) {
    <div class="alert alert-warning text-sm">
      <span>
        This tenant does not have a Quickbooks/Avatax ID. Please add one in the
        tenant settings.
      </span>
    </div>
  }
</div>
